import gql from 'graphql-tag';

import type { Job } from 'src/data/job';
import { executeGqlQuery, type GqlCallVariables, type GqlQueryOptions } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_JOB } from './schema';

const QUERY = gql`
  query JobStatus($id: ID!) {
    jobStatus(id: $id) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

interface Variables extends GqlCallVariables {
  id: ID;
}

export const queryJobStatus = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
): Promise<Job | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Job>(result.data);
};
